/**
 * Professional info form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import { Field } from 'redux-form';

import FormGroup from 'Components/FormGroup';
import { CustomFormInput } from 'Common/Form';
import { maxLengthValidation, requiredValidation } from 'Utils';
import { FormInterestsAutocomplete } from 'Common/ReduxForm';

const maxLength255 = maxLengthValidation(255);

export default function ProfessionalInfoForm(props) {
    return (
        <FormGroup title="form_groups.professional_info" {...props}>
            <Field
                withLabel
                rowClassName="mm-form-field"
                name="degree"
                component={CustomFormInput}
                type="text"
                label="degree"
                placeholder="degree"
                validate={[maxLength255]}
            />
            <Field
                withLabel
                rowClassName="mm-form-field"
                name="faculty"
                component={CustomFormInput}
                type="text"
                label="faculty"
                placeholder="faculty"
                validate={[maxLength255]}
            />
            <Field
                withLabel
                rowClassName="mm-form-field"
                name="department"
                component={CustomFormInput}
                type="text"
                label="department"
                placeholder="department"
                validate={[maxLength255]}
            />
            <Field
                withLabel
                rowClassName="mm-form-field"
                name="university"
                component={CustomFormInput}
                type="text"
                label="university"
                placeholder="university"
                validate={[maxLength255]}
            />
            <Field
                withLabel
                rowClassName="mm-form-field"
                name="interests"
                component={FormInterestsAutocomplete}
                label="interests"
                placeholder="interests"
                required
                validate={[requiredValidation]}
            />
        </FormGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/FormGroup/ProfessionalInfoForm.jsx